/* eslint-disable jsx-a11y/label-has-associated-control */
import { css } from '@emotion/react';
import { v4 as uuidv4 } from 'uuid';
import { ChangeEvent, forwardRef, InputHTMLAttributes } from 'react';
import cns from 'classnames';
import { withForm } from './withForm';
import { ContextProps } from './FormControlContext';

export const TOGGLE_CLASSNAME = '__mapui_toggle';

const applyMainStyles = () => (theme) => {
  const defaultStyle = css(theme.form.toggle.container);
  const styles = [defaultStyle];

  return css(...styles);
};

const inputStyle = () => (theme) => {
  const defaultStyle = css(theme.form.toggle.input);
  const styles = [defaultStyle];

  return css(...styles);
};

const labelStyle =
  ({ disabled }: Pick<ToggleProps, 'disabled'>) =>
  (theme) => {
    const defaultStyle = css(theme.form.toggle.label);
    const styles = [defaultStyle];

    if (disabled) {
      styles.push(css(theme.form.toggle.labelDisabled));
    }

    return css(...styles);
  };

const buttonStyle = () => (theme) => {
  const defaultStyle = css(theme.form.toggle.button);
  const styles = [defaultStyle];

  return css(...styles);
};

export interface ToggleProps
  extends InputHTMLAttributes<HTMLInputElement>,
    ContextProps {}

export const InternalToggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ className, disabled, onChange, id, ...rest }: ToggleProps, ref) => {
    const compId = uuidv4();

    const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
      if (!disabled && typeof onChange === 'function') {
        onChange(evt);
      }
    };

    return (
      <span
        css={applyMainStyles()}
        className={cns(TOGGLE_CLASSNAME, className)}
      >
        <input
          type="checkbox"
          className="__mapui_toggleInput"
          css={inputStyle()}
          id={id || compId}
          disabled={disabled}
          onChange={handleChange}
          {...rest}
          ref={ref}
        />
        <label
          css={labelStyle({ disabled })}
          className="__mapui_toggleLabel"
          htmlFor={id || compId}
        >
          <span className="__mapui_toggleButton" css={buttonStyle()} />
        </label>
      </span>
    );
  }
);

InternalToggle.displayName = 'Toggle';

export const Toggle = withForm<ToggleProps>(InternalToggle);
